/* Blue Skin – wishlist + quick add to cart (shared, all pages) */
(function () {
  if (window.bslWish) return;
  var KEY = 'bslWish';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var WL_URL = root + 'pages/wishlist';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.2-1.1C6.2 15.1 3.2 12.4 3.2 9A4.6 4.6 0 0 1 7.8 4.4c1.6 0 3.1.7 4.2 1.9a5.6 5.6 0 0 1 4.2-1.9A4.6 4.6 0 0 1 20.8 9c0 3.4-3 6.1-7.6 10.2L12 20.3z" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  function get() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} sync(); document.dispatchEvent(new CustomEvent('bsl:wish', { detail: a })); }
  function has(h) { return get().indexOf(h) > -1; }
  function toggle(h) { var a = get(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); save(a); return i === -1; }
  function remove(h) { var a = get(), i = a.indexOf(h); if (i > -1) { a.splice(i, 1); save(a); } }

  function sync() {
    var a = get();
    document.querySelectorAll('[data-bsl-wish]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-bsl-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      b.title = on ? 'Remove from wishlist' : 'Add to wishlist';
    });
    document.querySelectorAll('.bsl-wish-count').forEach(function (c) { c.textContent = a.length; c.hidden = !a.length; });
  }

  var toastEl, toastT;
  function toast(msg, href, linkText) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'bsl-wtoast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span></span>' + (href ? ' <a></a>' : '');
    toastEl.querySelector('span').textContent = msg;
    if (href) { var l = toastEl.querySelector('a'); l.href = href; l.textContent = linkText; }
    toastEl.classList.add('is-on'); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  function addToCart(id, btn) {
    if (btn) btn.classList.add('is-busy');
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var html = j.sections && j.sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (html && bubble) { var d = new DOMParser().parseFromString(html, 'text/html'); var s = d.querySelector('.shopify-section'); if (s) bubble.innerHTML = s.innerHTML; }
        var name = j.items && j.items[0] ? j.items[0].product_title : 'Item';
        toast(name + ' added to cart', root + 'cart', 'View cart');
        document.dispatchEvent(new CustomEvent('bsl:cart-added', { detail: j }));
      })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add to cart'); })
      .finally(function () { if (btn) btn.classList.remove('is-busy'); });
  }

  function closePops(except) {
    document.querySelectorAll('.bsl-qa__pop:not([hidden])').forEach(function (p) { if (p !== except) p.hidden = true; });
  }

  function headerIcon() {
    if (document.querySelector('.bsl-wish-link')) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    var a = document.createElement('a');
    a.href = WL_URL; a.className = 'header__icon header__icon--wishlist link focus-inset bsl-wish-link';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = '<span class="svg-wrapper">' + HEART.replace('<svg', '<svg class="icon icon-heart"') + '</span><span class="bsl-wish-count" hidden></span>';
    var cart = icons.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (cart) icons.insertBefore(a, cart); else icons.appendChild(a);
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-bsl-wish]');
    if (w) {
      e.preventDefault();
      var added = toggle(w.getAttribute('data-bsl-wish'));
      toast(added ? 'Saved to your wishlist' : 'Removed from your wishlist', added ? WL_URL : null, 'View wishlist');
      return;
    }
    var c = e.target.closest('[data-bsl-cart]');
    if (c) {
      e.preventDefault();
      var vid = c.getAttribute('data-variant-id');
      if (vid) { addToCart(vid, c); return; }
      var pop = c.closest('.bsl-qa-wrap') && c.closest('.bsl-qa-wrap').querySelector('.bsl-qa__pop');
      if (pop) { closePops(pop); pop.hidden = !pop.hidden; }
      return;
    }
    var v = e.target.closest('[data-bsl-add-variant]');
    if (v) {
      e.preventDefault();
      addToCart(v.getAttribute('data-bsl-add-variant'), v);
      var p = v.closest('.bsl-qa__pop'); if (p) p.hidden = true;
      return;
    }
    if (e.target.closest('[data-bsl-pop-close]')) { e.preventDefault(); closePops(); return; }
    if (!e.target.closest('.bsl-qa__pop')) closePops();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePops(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  function init() { headerIcon(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.bslWish = { get: get, has: has, toggle: toggle, remove: remove, sync: sync, addToCart: addToCart, toast: toast, url: WL_URL };
})();
